export default __webpack_public_path__ + "static/media/oreilly.8a1c7020.svg";